import { combineLatest, Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { PaymentService } from '@core/services/payment/payment.service';
import { PaymentStoreDispatcher } from '@common/dispatchers/payment.dispatcher';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  template: ``,
  selector: 'app-pat-payment-panel-lyfpay',
  standalone: false,
})
export class PatPaymentPanelLyfpayComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject<boolean>();

  constructor(
    private readonly paymentService: PaymentService,
    private paymentDispatcher: PaymentStoreDispatcher,
    private readonly analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.paymentDispatcher.updateUI({
      button: {
        isEnabled: false,
      },
      status: {
        isLoading: false,
      },
    });

    combineLatest([this.paymentService.pay$, this.paymentService.paymentLyfpayIntent$])
      .pipe(
        takeUntil(this.unsubscribe$),
        take(1),
        map(([_pay, paymentIntent]) => {
          if (paymentIntent?.payment_page_url) {
            window.location.href = paymentIntent.payment_page_url;
          } else {
            throw new Error('Payment intent is undefined');
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
